import React, { Fragment, useEffect, useState } from 'react';
import UserService from '../../services/userService';
import './styles.scss';
import AuthService from '../../services/authService';
import Insurance from '../../containers/Insurance';
import { Box, Typography } from '@mui/material';
import { User } from 'src/services/dto/Security';

interface InsuranceInfoProps {
  title?: string;
  subtitle?: string;
  onContinue: (user: User, providers: User[]) => void;
  defaultCards?: any[];
}

const InsuranceInfo = (props: InsuranceInfoProps) => {
  const { user } = AuthService.getAuth();
  const insuranceCardCheck = user?.insuranceCards.filter(
    (card) => !card.inProgress,
  );
  
  const [state, setState] = useState({
    hasInsurance: insuranceCardCheck?.length ? true : null,
    medicarePartB: !!user?.medicarePartB,
    medicaid: !!user?.medicaid,
    edit: false,
    addNew: false,
    upload: false,
    viewIndex: null,
    limitedCoverageStates: [] as string[],
    loading: true,
  });

  const setGenericState = (value: any) =>
    setState((state) => ({ ...state, ...value }));

  useEffect(() => {
    UserService.getLimitedCoverageStates()
      .then((res) => {
        setGenericState({ limitedCoverageStates: res?.data || [] });
      })
      .finally(() => setGenericState({ loading: false }));
  }, []);

  const patientInLimitedState = state.limitedCoverageStates.includes(user?.state || '');

  if (state.loading) return null;
  return (
    <div className="onboarding-form">
      <div className="header-info">
        <Box className="description" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <Typography variant="h5" fontWeight="bold">
            {state.upload
              ? 'Insurance Card Upload'
              : props.title || 'Health Insurance Info'}
          </Typography>
          {!state.upload && !state.edit && (
            patientInLimitedState ? (
              <Typography sx={{ fontSize: '16px !important', px: 1 }} variant="body1">
                Be sure to add your primary insurance and all secondary insurance plans.
              </Typography>
            ) : (
              <Typography variant="body1">
                {props.subtitle ||
                  `We accept most national plans and some regional plans
                depending on the area. If valid, this can cover most if not
                all of the cost of Ognomy.`}
              </Typography>
            )
          )}
          <Insurance
            onContinue={props.onContinue}
            defaultCards={props.defaultCards}
          />
        </Box>
      </div>

    </div>
  );
};

export default InsuranceInfo;
